export const dashboardLayoutTypeContext = 2;

export const DashboardComponentSavedReports = 'savedReports';

export const mySavedReportsId = 'mySavedReportsId';
